import { MDText } from 'i18n-react';

import { BankIcon, IconText } from '@motorway/mw-highway-code';

import { useSaleDetailsSub } from '../../hooks/useSaleDetailsSub';

import Texts from './PaymentDetails.texts.json';

import styles from './PaymentDetails.scss';

const LocalT = new MDText(Texts);

export const PaymentDetails = () => {
  const { accountNumber, hasNegativeEquity } = useSaleDetailsSub();

  if (!accountNumber || hasNegativeEquity) {
    return null;
  }

  const paymentDetails = <span>
    <span className={styles.account}>
      {LocalT.translate('accountEnding', { accountEnding: accountNumber })}
    </span>
    <span className={styles.paymentInfo}>
      {LocalT.translate('paymentAfterCollection')}
    </span>
  </span>;

  return (
    <div className={styles.paymentDetails}>
      <h2 className={styles.title}>{LocalT.translate('payment')}</h2>
      <div className={styles.details}>
        <IconText
          icon={BankIcon}
          text={paymentDetails}
          variant='small--regular' />
      </div>
    </div>
  );
};
